// extracted by mini-css-extract-plugin
export default {"btnWrapper":"itemCard_btnWrapper__WmyaC","productQuantityCounter":"itemCard_productQuantityCounter__CgDVX"};